// components/common/GenericDropdownButton.tsx

import IconArrowDownBold from 'assets/icons/arrow-down-bold.svg';
import cn from 'classnames';

interface SelectorButtonProps {
  className?: string;
  isOpen: boolean;
  children: React.ReactNode;
  onClick: () => void;
}

/**
 * Generic Need Capture button component that shows selected value and toggle arrow
 */
const SelectorButton: React.FC<SelectorButtonProps> = ({
  className,
  isOpen,
  children,
  onClick,
}) => {
  return (
    <button
      data-test="selector-button"
      className={cn(
        'bg-input-dark-bg-background text-text-dark-bg-contrast-white flex h-10 w-full items-center justify-between rounded-sm px-2.5 py-1.5 font-black lg:min-w-36',
        isOpen && 'ring-other-white ring-2',
        className
      )}
      onClick={onClick}
    >
      {children}

      <IconArrowDownBold
        data-test="selector-button-arrow"
        className={cn(
          'text-other-white h-2 w-3 shrink-0 transition-transform',
          isOpen && 'rotate-180'
        )}
      />
    </button>
  );
};

export default SelectorButton;
